import React from 'react';
import {
  Box, Grid, Container, Typography,
} from '@mui/material';
import { useTranslation } from '@gamiphy/react-i18n';
import StepCard from './StepCard';
import { useLoyaltyPageContext } from '../../context';

const HowItWorks:React.FC = () => {
  const { t } = useTranslation();
  const {
    isMobilePreview,
    colors: {
      buttonTextColor,
    },
    cashbackProgram: {
      cashbackPercentage,
      minPurchaseAmount,
      isCashbackProgram,
    },
    isCashbackEnabled,
  } = useLoyaltyPageContext();

  const steps = React.useMemo(() => [
    {
      id: '1',
      sn: 1,
      title: t('loyaltyPage.how.join', 'Join'),
      description: t('loyaltyPage.how.step1', 'Create an account to unlock our reward program benefits'),

    },

    {
      id: '2',
      sn: 2,
      title: t('loyaltyPage.how.earn', 'Earn'),
      description: t('loyaltyPage.how.step2', 'Get points for successful purchases and completed actions'),
    },
    {
      id: '3',
      sn: 3,
      title: t('loyaltyPage.how.redeem', 'Redeem'),
      description: t('loyaltyPage.how.step3', 'Redeem your points and get great discount and rewards'),

    },
  ], []);

  const cashbackProgramSteps = React.useMemo(() => [
    {
      id: '1',
      sn: 1,
      title: t('loyaltyPage.how.join', 'Join'),
      description: t('loyaltyPage.how.cashbackProgram.step1', 'Create an account and verify your phone number to unlock our reward program benefits'),

    },
    {
      id: '2',
      sn: 2,
      title: t('loyaltyPage.how.earn', 'Earn'),
      description: t(
        'loyaltyPage.how.cashbackProgram.step2',
        {
          defaultValue: 'Earn {{cashbackPercentage}}% cashback on every purchase you make over {{minPurchaseAmount, currency}}',
          cashbackPercentage,
          minPurchaseAmount,
        },
      ),
    },
    {
      id: '3',
      sn: 3,
      title: t('loyaltyPage.how.redeem', 'Redeem'),
      description: t('loyaltyPage.how.cashbackProgram.step3', 'Redeem your cashback discounts and get additional rewards'),

    },
  ], []);

  return (
    <Box
      py={{
        xs: 3,
        sm: 5,
      }}
      bgcolor="#fff"
    >
      <Container
        maxWidth="lg"
        disableGutters
      >
        <Typography variant="h1" gutterBottom sx={{ textAlign: 'center', textTransform: 'capitalize' }}>
          {' '}
          {t('loyaltyPage.how.title', 'How it Works') }
          {' '}
        </Typography>
        <Typography variant="body2" align="center">
          {isCashbackProgram && isCashbackEnabled
            ? (
              t('loyaltyPage.how.subtitle.cashbackProgram', 'Earn a cashback discount in a few steps')
            )
            : (
              t('loyaltyPage.how.subtitle', 'Earn gift and get discounts in a few easy steps.')
            )}
        </Typography>
      </Container>
      <Container
        maxWidth="lg"
        sx={{
          mt: {
            xs: 4.5,
            sm: 9,
          },
        }}

      >
        <Grid container rowSpacing={3} justifyContent="space-evenly">
          {isCashbackProgram ? (
            <>
              {cashbackProgramSteps.map((step) => (
                <Grid key={step.id} size={{ xs: 12, sm: isMobilePreview ? 12 : 3 }}>
                  <StepCard num={step.sn} title={step.title} description={step.description} isMobilePreview={isMobilePreview} buttonTextColor={buttonTextColor} />
                </Grid>
              ))}
            </>
          ) : (
            <>
              {steps.map((step) => (
                <Grid key={step.id} size={{ xs: 12, sm: isMobilePreview ? 12 : 3 }}>
                  <StepCard num={step.sn} title={step.title} description={step.description} isMobilePreview={isMobilePreview} buttonTextColor={buttonTextColor} />
                </Grid>
              ))}
            </>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorks;
